package net.bothosting.docs.pages.troubleshooting

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.*
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.layout.NoLayout
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobwebx.frontmatter.*
import com.varabyte.kobwebx.markdown.*

@InitRoute
fun initServer_rate_limitsPage(ctx: InitRouteContext) {
    ctx.data.add(MarkdownContext("troubleshooting/server_rate_limits.md", FrontMatterElement.EmptyMap))
}

@Page("/troubleshooting/server-rate-limits")
@Layout(".components.layouts.DocsLayout")
@Composable
fun Server_rate_limitsPage() {
    org.jetbrains.compose.web.dom.H1(attrs = { id("server-rate-limits") }) {
        org.jetbrains.compose.web.dom.Text("Server Rate Limits")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Servers created on ")
        org.jetbrains.compose.web.dom.Code {
            org.jetbrains.compose.web.dom.Text("bot-hosting.net")
        }
        org.jetbrains.compose.web.dom.Text(" typically share an outbound IP address with a small number of other servers (usually 2–5).")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("In some cases, another user on the same IP may exceed usage limits. When this happens, the IP can be temporarily blocked from accessing certain APIs, which may cause errors in your server console.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("These errors often appear as an HTML page with a Cloudflare message indicating that access to ")
        org.jetbrains.compose.web.dom.Code {
            org.jetbrains.compose.web.dom.Text("discord.com")
        }
        org.jetbrains.compose.web.dom.Text(" has been temporarily restricted.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.B {
            org.jetbrains.compose.web.dom.Text("What you can do:")
        }
    }
    org.jetbrains.compose.web.dom.Ul {
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("This issue is usually temporary and resolves on its own")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("If it persists, open a support ticket")
        }
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Administrators can update your server’s outbound IP address to restore normal access as soon as possible.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("If you are using the ")
        org.jetbrains.compose.web.dom.Code {
            org.jetbrains.compose.web.dom.Text("discord.js")
        }
        org.jetbrains.compose.web.dom.Text(" package, you need to listen to REST events to detect when your application is being rate limited.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("By default, ")
        org.jetbrains.compose.web.dom.Code {
            org.jetbrains.compose.web.dom.Text("discord.js")
        }
        org.jetbrains.compose.web.dom.Text(" handles rate limits internally and retries requests automatically, without notifying you. This means you may not immediately realize when your bot is being limited.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("To monitor this, you can listen to REST events and check for specific response codes, such as:")
    }
    org.jetbrains.compose.web.dom.Ul {
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.B {
                org.jetbrains.compose.web.dom.Text("403")
            }
            org.jetbrains.compose.web.dom.Text(" – Forbidden (access denied)")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.B {
                org.jetbrains.compose.web.dom.Text("429")
            }
            org.jetbrains.compose.web.dom.Text(" – Rate limited")
        }
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Below is an example of how to listen for REST events and handle these cases:")
    }
    org.jetbrains.compose.web.dom.Pre { org.jetbrains.compose.web.dom.Code { org.jetbrains.compose.web.dom.Text("""client.rest.on(RESTEvents.Response, (Req, Resp) => {
    if (!(Resp.status === 403 || Resp.status === 429)) return;
    console.log('Rate limited!')
});
""") } }
    org.jetbrains.compose.web.dom.Ul {
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("\"client\" is a ")
            com.varabyte.kobweb.silk.components.navigation.Link("https://discord.js.org/docs/packages/discord.js/main/Client:Class") {
                org.jetbrains.compose.web.dom.Text("Client")
            }
            org.jetbrains.compose.web.dom.Text(" instance")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("\"")
            com.varabyte.kobweb.silk.components.navigation.Link("https://discord.js.org/docs/packages/discord.js/main/RestEvents:Interface") {
                org.jetbrains.compose.web.dom.Text("RESTEvents")
            }
            org.jetbrains.compose.web.dom.Text("\" can be imported from discord.js")
        }
    }
}
